module.exports = __webpack_public_path__ + "fonts/de566c0eb4f05174ba15fa0520066c24.svg";